// docs for router https://github.com/thepassle/app-tools/blob/master/router/README.md

import { html } from 'lit'

if (!(globalThis as any).URLPattern) {
  await import("urlpattern-polyfill")
}

import { Router } from '@thepassle/app-tools/router.js'

import './pages/app-opening-hours.js'

const baseURL: string = (import.meta as any).env.BASE_URL

export const router = new Router({
    routes: [
      {
        path: resolveRouterPath(),
        title: 'Home',
        render: () => {
          // Redirect to a default restaurant or show a message
          // Since restaurants will have predefined URLs, the home page should redirect
          window.location.href = resolveRouterPath('1')
          return html`<div>Redirecting...</div>`
        }
      },
      {
        path: resolveRouterPath(':restaurantId'),
        title: 'Opening Hours',
        render: (context) => {
          const secretKey = new URL(window.location.href).searchParams.get('key')
          return html`<app-opening-hours .restaurantId=${context.params.restaurantId} .secretKey=${secretKey}></app-opening-hours>`
        }
      },
      {
        path: resolveRouterPath(':restaurantId/opening-hours'),
        title: 'Opening Hours',
        render: (context) => {
          const secretKey = new URL(window.location.href).searchParams.get('key')
          return html`<app-opening-hours .restaurantId=${context.params.restaurantId} .secretKey=${secretKey}></app-opening-hours>`
        }
      }
    ]
  })

export function resolveRouterPath(unresolvedPath?: string) {
  var resolvedPath = baseURL
  if(unresolvedPath) {
    resolvedPath = resolvedPath + unresolvedPath
  }
  return resolvedPath
}
